/**
 * Variable descriptors for Roman Numeral to Integer conversion.
 *
 * @type {object}
 * @property {number} M - The value of Roman Numeral 'M' which is 1000.
 * @property {number} CM - The value of Roman Numeral 'CM' which is 900.
 * @property {number} D - The value of Roman Numeral 'D' which is 500.
 * @property {number} CD - The value of Roman Numeral 'CD' which is 400.
 * @property {number} C - The value of Roman Numeral 'C' which is 100.
 * @property {number} XC - The value of Roman Numeral 'XC' which is 90.
 * @property {number} L - The value of Roman Numeral 'L' which is 50.
 * @property {number} XL - The value of Roman Numeral 'XL' which is 40.
 * @property {number} X - The value of Roman Numeral 'X' which is 10.
 * @property {number} IX - The value of Roman Numeral 'IX' which is 9.
 * @property {number} V - The value of Roman Numeral 'V' which is 5.
 * @property {number} IV - The value of Roman Numeral 'IV' which is 4.
 * @property {number} I - The value of Roman Numeral 'I' which is 1.
 */

const descriptors = {
  M: 1000,
  CM: 900,
  D: 500,
  CD: 400,
  C: 100,
  XC: 90,
  L: 50,
  XL: 40,
  X: 10,
  IX: 9,
  V: 5,
  IV: 4,
  I: 1,
};

/**
 * Converts a given number to Roman numerals.
 *
 * @param {number} number - The number to be converted.
 * @return {string} - The Roman numeral representation of the given number.
 */
export function numberToRomanNumerals(number = 0) {
  return Object.keys(descriptors).reduce((acc, key) => {
    while (number >= descriptors[key]) {
      acc += key;
      number -= descriptors[key];
    }

    return acc;
  }, '');
}

/**
 * Converts a Roman numeral to its equivalent number.
 *
 * @param {string} roman - The Roman numeral to be converted.
 * @returns {number} - The equivalent number value of the Roman numeral.
 */
export function romanNumeralsToNumber(roman = '') {
  return Object.keys(descriptors).reduce((acc, key) => {
    while (roman.indexOf(key) === 0) {
      acc += descriptors[key];

      roman = roman.substr(key.length);
    }

    return acc;
  }, 0);
}

// console.log(toRoman(1903));  // should return 'MCMIII
// console.log(fromRoman('MCMIII')); // should return 1903
